import { every, flatten, forEach, get, includes, isEmpty, isNil, isNumber, isObject, map, memoize, set, uniqBy } from "lodash"
import moment from "moment"
import "moment-timezone"
import Cookies from "universal-cookie"
import {
	ALLOWED_ACTIONS,
	AppTenants,
	ConsultationStatusConstant,
	ConsultationType,
	ConsultDoctorType,
	FileType,
	GoalMeasureFrequencyType,
	OPS_BOOKING_CONSTANTS,
	PSYCHOLOGIST_SUB_SERVICE_TYPE,
	RoleNames,
	ShiftStatus,
	TEXT_BLOG_DEEPLINK_TEMPLATE,
	USER_LIFESTYLE_MAP,
	VIDEO_BLOG_OR_INFO_BITE_DEEPLINK_TEMPLATE,
	VitalsEditSourceName,
} from "../constants"
import { store as reduxStore } from "../reducers/rootReducer"
import { WatchmenMembership } from "../interfaces/watchmen"
import { IUserInfo } from "../interfaces/chat/whatsAppChat"
import { IPatientDetail } from "../interfaces/patient/patients"
import IRole from "../interfaces/IRole"
import { getOpenedDoctorProfileForAdmin, setOpenedDoctorProfileForAdmin } from "./localStorage"
import { GlobalToken, SelectProps } from "antd"
import { IDayEpochInfo, IHourInfo } from "../interfaces/calendar/IHourInfo"
import { IAppointment } from "../interfaces/api/albus/appointment"
import { IResourceSchedule } from "../interfaces/roster/IRoster"
import { IPrescriptionMedication } from "../interfaces/patient/IPrescriptionMedication"
import { IPrescriptionMedicine } from "../interfaces/patient/IPrescriptionMedicine"
import { IMedicationItem, ISlotList } from "../interfaces/patient/IMedication"
import { MedicineSlot } from "../components/patient/medication/helper"
import { IPatientGoal } from "../interfaces/patient/IPatientGoals"
import { referralStaticData } from "../components/patient/ongoingConsultation/prescription/helper"
import { IConstituentTemplate } from "../interfaces/IPdfTemplate"
import {
	adherenceTemplate,
	bundlePackBanner,
	conditionAssessmentTemplate,
	currentVisitSummaryTemplate,
	doctorSignatureTemplate,
	faceBasedVitalsTemplate,
	goalsRecommendationTemplate,
	goalsTemplate,
	patientDoctorInfoTemplate,
	patientHealthOverviewTemplate,
	patientVitalTableTemplate,
	prescriptionActiveFoodsTemplate,
} from "../components/patient/consultation/template/templates"
import { IContentNameMapRHS } from "../containers/StartConvesationContainer/StartConversationContainer"
import { ISelectionStringRange } from "../containers/patient/NoteWithActions/types"
import { AxiosError } from "axios"
import { IFetchUserAutomatedPublicNotesResponse } from "../interfaces/api/chs/IUserAutomatedPublicNotes"
import { IIntervention } from "../interfaces/patient/IPatientInterventions"
import { ICgmRequestStatus } from "../interfaces/api/sms/ICgmRequest"
import { ColumnsType } from "antd/es/table"
import { getOneHourSlotFromStartEpoch } from "./DateUtils"
import { IDishNutritionInfo } from "../interfaces/api/ambrosia/IMealOption"
import { AlarmOnRounded, CheckCircleRounded, DocumentScannerRounded, MissedVideoCall, MissedVideoCallRounded, SaveAsRounded, TodayRounded } from "@mui/icons-material"
import { COACH_COMMUNITY_TYPE_ENUM, IChatConversationSummary } from "../interfaces/api/nest/filterCoachCoachCommunities"
import { DIET_PLAN_SAVE_STATUS, IDietTemplate, IDietTheme, IUserMealPlan } from "../interfaces/api/ambrosia/fetchUserMealPlan"
import { APP_STAGE, ENV } from "../../../server/src/configs/configs"
import { AvailableAppLanguages } from "../interfaces/api/chs/getUserAppLanguagePreference"
import IDoctorProfile from "../interfaces/doctor/IDoctorProfile"

// const digitsLookup = [
//   { value: 1, symbol: "" },
//   { value: 1e3, symbol: "k" },
//   { value: 1e6, symbol: "M" },
//   { value: 1e9, symbol: "G" },
//   { value: 1e12, symbol: "T" },
//   { value: 1e15, symbol: "P" },
//   { value: 1e18, symbol: "E" },
// ];
//
// export const getSelectOptions = (
//   rawOptions: any[],
//   labelKey: string,
//   valueKey: string
// ) => {
//   if (!rawOptions) return [];
//   return rawOptions.map((rawOption: any) => ({
//     ...rawOption,
//     label: get(rawOption, `${labelKey}`, ""),
//     value: get(rawOption, `${valueKey}`, ""),
//   }));
// };

// export const convertQueryParamsToString = (queryParams: any) => {
//   let url = "";
//   let count = 0;
//   for (const property in queryParams) {
//     if (queryParams.hasOwnProperty(property)) {
//       count += 1;
//       url += `${count <= 1 ? "?" : "&"}${property}=${queryParams[property]}`;
//     }
//   }
//   return url;
// };
//
// export const convertQueryStringToObject = (queryParams: string) => {
//   if (queryParams) {
//     const transformedObject: any = {};
//     const firstSplit = queryParams.split("?");
//     const firstObjects = firstSplit.length > 1 ? firstSplit[1].split("&") : [];
//     firstObjects.forEach((obj: any) => {
//       const keyValuePair = obj.split("=");
//       if (keyValuePair[1] !== "undefined") {
//         transformedObject[keyValuePair[0]] = keyValuePair[1];
//       }
//     });
//     return transformedObject;
//   } else {
//     return {};
//   }
// };
//
// export const getPageInfo = (
//   location: Location | undefined,
//   defaultPageSize = 20
// ): Record<string, number> => {
//   if (location) {
//     const queryParams = convertQueryStringToObject(location.pathname);
//     const currentPage = queryParams.page ? parseInt(queryParams.page) : 1;
//     const offset = currentPage - 1;
//     const pageSize = queryParams.pageSize
//       ? parseInt(queryParams.pageSize)
//       : defaultPageSize;
//     return { queryParams, currentPage, offset, pageSize };
//   }
//   return {};
// };
//
// export const getErrorsForField = (
//   props: any,
//   fieldKey: string,
//   ignoreTouch?: boolean
// ): string => {
//   const fieldError = _.get(props.errors, fieldKey, "");
//   const fieldTouched = _.get(props.touched, fieldKey, "");
//   if (ignoreTouch) {
//     return props?.errors && fieldError ? fieldError : "";
//   }
//   return props?.errors && fieldError && (fieldTouched || props.submitCount >= 1)
//     ? fieldError
//     : "";
// };
//
// export const handleImageError = (event: any) => {
//   event.target.src = placeholderImage;
// };
//
// export function range(start: number, end: number) {
//   const result = [];
//   for (let i = start; i < end; i++) {
//     result.push(i);
//   }
//   return result;
// }
//
// export async function copyTextToClipboard(text: string): Promise<void> {
//   await navigator.clipboard.writeText(text);
// }
//
// export function isDateTimeToday(dateTime?: moment.Moment | number): boolean {
//   return dateTime
//     ? moment(dateTime).startOf("day").isSame(moment().startOf("day"))
//     : false;
// }

// export function isDateTimeTomorrow(datetime?: moment.Moment | number): boolean {
//   return datetime
//     ? moment(datetime)
//         .startOf("day")
//         .isSame(moment().add(1, "day").startOf("day"))
//     : false;
// }
//
// export function isCurrentHour(dateTime?: moment.Moment | number): boolean {
//   const isCurrent = dateTime
//     ? moment(dateTime).startOf("hour").isSame(moment().startOf("hour"))
//     : false;
//   return isCurrent;
// }
//
// export function isStageEnv(): boolean {
//   return !!window.location.hostname.match(/stage/gim);
// }
//
// export const isStageOrLocalEnv = () => {
//   const host = window.location.hostname;
//   return !!(host.match(/stage/gim) || host.match(/localhost/gim));
// };
//
// export function delay(ms: number): Promise<any> {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }
//
// export const convertQueryParamsToStringV2 = (params: any): string => {
//   if (params) {
//     const queryParams = new URLSearchParams(Object.entries(params));
//     return `?${queryParams.toString()}`;
//   }
//   return "";
// };
//
// export function numberFormatter(num: number, digitsInDecimal: number) {
//   if (num === 0) {
//     return 0;
//   }
//   const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
//   const item = digitsLookup
//     .slice()
//     .reverse()
//     .find(function (item) {
//       return num >= item.value;
//     });
//   return item
//     ? (num / item.value).toFixed(digitsInDecimal).replace(rx, "$1") +
//         item.symbol
//     : "0";
// }
//
// export function easeOutQuint(x: number): number {
//   return 1 - Math.pow(1 - x, 5);
// }
//
// export const sanitiseQueryParams = (
//   queryParams: Record<string, any>
// ): Record<string, any> => {
//   const newQueryParams = { ...queryParams };
//   // sanitise query params - remove null/undefined values
//   Object.keys(newQueryParams).forEach((param: string) => {
//     if (
//       typeof newQueryParams[param] !== "number" &&
//       _.isEmpty(newQueryParams[param]) &&
//       _.isNil(newQueryParams[param])
//     ) {
//       delete newQueryParams[param];
//     }
//   });
//   return newQueryParams;
// };

// export function removeItems(
//   elements: Array<any>,
//   indices: number[]
// ): Array<any> {
//   // traverse from last so indices don't mess up.
//   const sortedIndices = indices.sort((a, b) => a - b);
//   const newElements = [...elements];
//   for (let i = sortedIndices.length - 1; i >= 0; i--) {
//     newElements.splice(sortedIndices[i], 1);
//   }
//   return newElements;
// }

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
export const SHORT_MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const WEEK_DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

export const getIsConverseChatUserUsingCookiesFlag = (useCookies?: boolean) => {
	const cookies = new Cookies()
	const memberships: IRole[] = useCookies ? get(cookies.get("userContext"), "memberships", []) : reduxStore.getState()?.accountData?.memberships
	if (!isEmpty(memberships)) {
		const converseChatMembership = memberships.find((role: any) => role.roleName === RoleNames.CONVERSE_CHAT)
		return !isEmpty(converseChatMembership)
	}
	return false
}

export const getIsConverseChatUser = () => {
	return getIsConverseChatUserUsingCookiesFlag(true) || getIsConverseChatUserUsingCookiesFlag(false)
}

export const getIsAdminUsingCookies = (): boolean => {
	const cookies = new Cookies()
	const memberships: WatchmenMembership[] = get(cookies.get("userContext"), "memberships", [])
	return memberships.findIndex((membership) => membership.roleName === RoleNames.ADMIN) !== -1
}

export const getIsAdminUsingReduxStore = (): boolean => {
	const memberships: IRole[] = reduxStore.getState()?.accountData?.memberships
	if (!isEmpty(memberships)) {
		const adminMembership = memberships.find((role: any) => role.roleName === RoleNames.ADMIN)
		return !isEmpty(adminMembership)
	}
	return false
}

export const getIsAgentAdmin = (): boolean => {
	return getIsAdminUsingReduxStore() || getIsAdminUsingCookies()
}

export const getWhatsAppNumberToUse = (patientDetail: IPatientDetail, userInfo: IUserInfo): string => {
	if (userInfo?.whatsAppNumber) return userInfo.whatsAppNumber
	return patientDetail?.phoneNumber || patientDetail?.userPhoneNumber
}

export const getIsMobile = () => {
	let check = false
	const userAgent = navigator.userAgent || navigator.vendor
	if (
		// tslint:disable-next-line
		/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
			userAgent
		) || // tslint:disable-next-line
		/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
			userAgent.substr(0, 4)
		)
	) {
		check = true
	}
	return check
}

export const getDoctorTenant = (): string => {
	return reduxStore?.getState()?.doctorTenant
}
export const getPatientTenant = (): string => {
	const tenant = reduxStore?.getState()?.patientData?.tenant
	return tenant != AppTenants.ULTRAFIT ? AppTenants.SUGARFIT : AppTenants.ULTRAFIT
}

export const getTimeString = (seconds: number) => {
	const h = Math.floor(seconds / 3600)
	const m = Math.floor((seconds % 3600) / 60)
	const s = Math.floor((seconds % 3600) % 60)

	const hDisplay = h > 0 ? h + (h == 1 ? " h, " : " h, ") : ""
	const mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : ""
	const sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : ""
	return hDisplay + mDisplay + sDisplay
}

export const getOdinTenantId = (): number => {
	return window.location.hostname?.includes("stage") ? 15 : 12 // stage: 15, prod/alpha: 12
}

export const areSameDates = (timestamp1: number, timestamp2: number) => {
	const dtFormat = new Intl.DateTimeFormat("en")
	const t1 = isNil(timestamp1) ? new Date() : new Date(timestamp1)
	const t2 = isNil(timestamp2) ? new Date() : new Date(timestamp2)
	return dtFormat.format(t1) === dtFormat.format(t2)
}

export const capitaliseText = (inputText: string): string => {
	if (inputText === null || inputText === undefined) return ""
	let lowerCaseText = inputText.toLowerCase()
	if (lowerCaseText.includes("_")) lowerCaseText = lowerCaseText.split("_").join(" ")
	return lowerCaseText
		.split(" ")
		.map((text) => text.slice(0, 1).toUpperCase() + text.slice(1))
		.join(" ")
}

export const getSelectedDoctor = () => {
	return getOpenedDoctorProfileForAdmin() || reduxStore?.getState()?.doctorProfile
}

export const logout = () => {
	setOpenedDoctorProfileForAdmin()
	// Hand off to the server-side /logout route. On sf-prod terminus clears
	// the session cookies + invalidates the IMS token + redirects to
	// accounts.sugarfit.org. On cf-prod cf-commons-middleware does the same
	// against accounts.curefit.co.
	window.location.href = "/logout"
}

export const getConsultationStatusColor = (status: string, theme: GlobalToken) => {
	switch (status) {
		case ConsultationStatusConstant.CONSULTATION_COMPLETED:
			return theme.colorSuccessHover
		case ConsultationStatusConstant.COMPLETED:
			return theme.colorSuccessHover
		case ConsultationStatusConstant.EDIT_PRESCRIPTION_COMPLETED:
			return theme.colorSuccessHover
		case ConsultationStatusConstant.CONSULTATION_STARTED:
			return theme.colorInfoHover
		case ConsultationStatusConstant.PRESCRIPTION_GENERATED:
			return theme.colorWarningHover
		case ConsultationStatusConstant.EDIT_PRESCRIPTION_GENERATED:
			return theme.colorWarningHover
		case ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT:
			return theme.colorWarningHover
		case ConsultationStatusConstant.SCHEDULED:
			return theme.colorInfoHover
		case ConsultationStatusConstant.MISSED:
			return theme.colorErrorHover
		case ConsultationStatusConstant.CUSTOMER_MISSED:
			return theme.colorErrorHover
		default:
			return theme.colorInfoHover
	}
}

export const getConsultationStatusIcon = (status: string) => {
	switch (status) {
		case ConsultationStatusConstant.CONSULTATION_COMPLETED:
		case ConsultationStatusConstant.COMPLETED:
		case ConsultationStatusConstant.EDIT_PRESCRIPTION_COMPLETED:
			return CheckCircleRounded
		case ConsultationStatusConstant.CONSULTATION_STARTED:
			return AlarmOnRounded
		case ConsultationStatusConstant.PRESCRIPTION_GENERATED:
		case ConsultationStatusConstant.EDIT_PRESCRIPTION_GENERATED:
			return DocumentScannerRounded
		case ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT:
			return SaveAsRounded
		case ConsultationStatusConstant.SCHEDULED:
			return TodayRounded
		case ConsultationStatusConstant.MISSED:
		case ConsultationStatusConstant.CUSTOMER_MISSED:
			return MissedVideoCallRounded
		default:
			return null
	}
}

export class EpochConstants {
	static EPOCH_IN_A_SEC = 1000
	static EPOCH_IN_A_MIN: number = 60 * EpochConstants.EPOCH_IN_A_SEC
	static EPOCH_IN_AN_HOUR: number = 60 * EpochConstants.EPOCH_IN_A_MIN
	static EPOCH_IN_AN_DAY: number = 24 * EpochConstants.EPOCH_IN_AN_HOUR
}

export const getHourSplitOfDay = (): IHourInfo[] => {
	const timeSplits = []
	let meridien = "AM"
	const epochInHalfHour = EpochConstants.EPOCH_IN_AN_HOUR / 2
	for (let i = 0; i < 24; i++) {
		timeSplits.push({
			offset: i * epochInHalfHour,
			meridien: meridien,
			display: Math.floor(i / 2) + ":" + (i % 2 === 0 ? "00" : "30"),
		})
	}
	meridien = "PM"
	for (let i = 0; i < 24; i++) {
		const hourDisplay = Math.floor(i / 2) < 1 ? "12" : Math.floor(i / 2)
		const display = hourDisplay + ":" + (i % 2 === 0 ? "00" : "30")
		timeSplits.push({ offset: (24 + i) * epochInHalfHour, meridien: meridien, display })
	}
	return timeSplits
}

export const getHourlySplitOfDay = (): IHourInfo[] => {
	const timeSplits = []
	let meridien = "AM"
	const epochInHour = EpochConstants.EPOCH_IN_AN_HOUR
	for (let i = 0; i < 12; i++) {
		timeSplits.push({
			offset: i * epochInHour,
			meridien,
			display: String(i || 12),
		})
	}
	meridien = "PM"
	for (let i = 0; i < 12; i++) {
		timeSplits.push({
			offset: (12 + i) * epochInHour,
			meridien,
			display: String(i || 12),
		})
	}
	return timeSplits
}

export const get20MinsSplitOfDay = (): IHourInfo[] => {
	const timeSplits = []
	let meridien = "AM"
	const epochIn20Mins = EpochConstants.EPOCH_IN_A_MIN * 20
	for (let i = 0; i < 36; i++) {
		timeSplits.push({
			offset: i * epochIn20Mins,
			meridien,
			display: String((Math.floor(i/3) || 12).toLocaleString(undefined, {minimumIntegerDigits: 2})) + ":" + String((i%3 * 20).toLocaleString(undefined, {minimumIntegerDigits: 2})),
		})
	}
	meridien = "PM"
	for (let i = 0; i < 36; i++) {
		timeSplits.push({
			offset: (12 + i) * epochIn20Mins,
			meridien,
			display: String((Math.floor(i/3) || 12).toLocaleString(undefined, {minimumIntegerDigits: 2})) + ":" +  String((i%3 * 20).toLocaleString(undefined, {minimumIntegerDigits: 2})),
		})
	}
	return timeSplits
}


export const getListOfDays = (startEpoch: number, noOfDays: number): IDayEpochInfo[] => {
	const endEpoch = startEpoch + noOfDays * EpochConstants.EPOCH_IN_AN_DAY
	const daysList: IDayEpochInfo[] = []
	let currDayEpoch = startEpoch
	while (currDayEpoch < endEpoch) {
		const momentTime = moment(currDayEpoch)
		daysList.push({
			startEpoch: currDayEpoch,
			endEpoch: currDayEpoch + EpochConstants.EPOCH_IN_AN_DAY,
			dateText: momentTime.date().toString(),
			display: momentTime.format("DD, MMM"),
			dayOfWeek: momentTime.format("dddd"),
			month: momentTime.format("MMM"),
			dayShortForm: momentTime.format("ddd"),
		})
		currDayEpoch = currDayEpoch + EpochConstants.EPOCH_IN_AN_DAY
	}
	return daysList
}

export const isSameDay = (epoch1: number, epoch2: number) => {
	return moment(epoch1).isSame(epoch2, "day")
}

export const getDayEpochInfo = (epoch: number): IDayEpochInfo => {
	const start = new Date(epoch)
	start.setHours(0, 0, 0, 0)
	const monthText = moment(epoch).format("MMM")
	return {
		startEpoch: start.getTime(),
		endEpoch: start.getTime() + EpochConstants.EPOCH_IN_AN_DAY,
		display: "",
		dateText: start.getDate().toString(),
		month: monthText,
		year: start.getFullYear().toString(),
	}
}

export const isActionAllowedForConsultation = (consultation: IAppointment) => {
	return !isEmpty(consultation) && !isEmpty(consultation.availableDoctorActions)
}

export const isStartActionAllowedForConsultation = (consultation: IAppointment) => {
	if(consultation?.status === ConsultationStatusConstant.MISSED || consultation?.status === ConsultationStatusConstant.CUSTOMER_MISSED){
		return false
	}
	return isActionAllowedForConsultation(consultation) && consultation.availableDoctorActions.indexOf(ALLOWED_ACTIONS.START_CONSULTATION) > -1
}

export const isLifeStyleConsultation = (appointmentSchedule: IAppointment) => {
	return appointmentSchedule?.consultationSellableProduct?.consultationProduct?.subServiceType === ConsultDoctorType.LC
}

export const getAgeFromRecordedAge = (recordedAge: number, recordedDate: any) => {
	const recordedDt: any = new Date(recordedDate)
	const currentDate: any = new Date()
	return recordedAge + moment.duration(currentDate - recordedDt).years()
}

export const getPackDetails = (appointment: IAppointment) => {
	if (appointment.packInfo.length > 1) {
		// RollbarUtils.sendErrorToRollbar(new Error("Got more than one booking membership pack details for LC."), {
		// 	doctorId: appointment.doctor.id,
		// 	appointmentId: appointment.id,
		// });
		return null
	} else {
		return appointment.packInfo[0]
	}
}

export const isInCenterConsult = (appointmentSchedule: IAppointment) => {
	return appointmentSchedule?.prescriptionType !== "ONLINE_CONSULT_PRESCRIPTION" && appointmentSchedule?.consultationProduct?.productSpecs?.prescriptionType === "EXPERIENCE_CENTER"
}

export const getEpochFromDateAndTime = (epochInMs: number, timeInHHMM: string): number => {
	const [hour, min] = timeInHHMM.split(":")
	return new Date(epochInMs).setHours(Number(hour), Number(min), 0, 0)
}

export const parseRosterDataWithBreaksToWIthoutBreaks = (data: IResourceSchedule[]): IResourceSchedule[] => {
	const parsedData: IResourceSchedule[] = []
	data = data.filter(({ availableOnline }) => availableOnline)
	data.forEach((shift: IResourceSchedule) => {
		shift.resourceDeallocationScheduleList = shift.resourceDeallocationScheduleList.filter(({ scheduleStatus }) => scheduleStatus === ShiftStatus.ACTIVE)
		if (shift.resourceDeallocationScheduleList.length === 0) {
			parsedData.push(shift) // when no deallocations present
		} else {
			const { workingDayDate, startTime, endTime } = shift
			const workStartTimeEpoch: number = getEpochFromDateAndTime(workingDayDate, startTime)
			const workEndTimeEpoch: number = getEpochFromDateAndTime(workingDayDate, endTime)

			for (let breakCount = 0; breakCount <= shift.resourceDeallocationScheduleList.length; breakCount++) {
				const deallocation = shift.resourceDeallocationScheduleList[breakCount]
				let actualStartEpoch: number
				let actualEndEpoch: number
				if (breakCount === 0) {
					actualStartEpoch = workStartTimeEpoch
				} else {
					const previousBreakEndTime = shift.resourceDeallocationScheduleList[breakCount - 1].endTime
					actualStartEpoch = getEpochFromDateAndTime(workingDayDate, previousBreakEndTime)
				}

				if (breakCount === shift.resourceDeallocationScheduleList.length) {
					actualEndEpoch = workEndTimeEpoch
				} else {
					const nextBreakStartTime = shift.resourceDeallocationScheduleList[breakCount].startTime
					actualEndEpoch = getEpochFromDateAndTime(workingDayDate, nextBreakStartTime)
				}
				if (actualStartEpoch != actualEndEpoch) {
					parsedData.push({
						...shift,
						startTime: moment(actualStartEpoch).format("HH:mm"),
						endTime: moment(actualEndEpoch).format("HH:mm"),
						isSplitShift: true,
					})
				}
			}
		}
	})
	return parsedData
}

export const getListOfYears = memoize((noOfYears?: number, tillYear?: number) => {
	const startYear = noOfYears || moment().year() - tillYear + 1
	return new Array(startYear).fill(0).map((_, index) => {
		const year = moment().subtract(index, "years").format("YYYY")
		return {
			label: year,
			value: year,
		}
	})
})

export const getTimeInSecondsFromMinutes = (time: string) => {
	let timeInSeconds = null
	const splitArray = time.split(".")
	const minutes = splitArray[0] ? parseInt(splitArray[0]) : 0
	const seconds = splitArray[1] ? parseInt(splitArray[1]) : 0
	timeInSeconds = minutes * 60 + seconds
	return timeInSeconds.toString()
}

export const getTimeInSecondsFromHours = (time: string) => {
	let timeInSeconds = null
	const splitArray = time.split(".")
	const hours = splitArray[0] ? parseInt(splitArray[0]) : 0
	const minutes = splitArray[1] ? parseInt(splitArray[1]) : 0
	timeInSeconds = hours * 3600 + minutes * 60
	return timeInSeconds.toString()
}

export const createOldMedicinePrescription = (medicinePrescription: IPrescriptionMedication, patientId: number): IPrescriptionMedicine => {
	const medicinePrescriptionList = map(medicinePrescription?.prescriptionMedicationList, (pres): IMedicationItem => {
		return {
			brand: {
				internalValue: get(pres, "medicineDetails.productName"),
				displayValue: get(pres, "medicineDetails.productName"),
			},
			genericName: {
				internalValue: get(pres, "medicineDetails.molecule"),
				displayValue: get(pres, "medicineDetails.molecule"),
			},
			medicineType: get(pres, "medicineDetails.dosageForm"),
			dosage: pres.dosage,
			medicineDosage: pres.dosage,
			code: pres.code,
			frequency: pres.frequency,
			medicineInstructions: pres.instructions,
			medicineQuantity: get(pres, "metadata.quantity"),
			medicineDuration: get(pres, "metadata.duration"),
			slotList: get(pres, "metadata.slotList"),
			comments: get(pres, "metadata.comments"),
			// Preserve Ambrosia tags so client-side category checks (e.g. anyGlp1
			// looking for category=glp1) still match after a prescription is loaded
			// or applied via the Previous Prescriptions section. Without this the
			// derived medicines arrive without tags, hasGlp1Medicine evaluates to
			// false, and the FM Save & Complete flow skips the IM review modal.
			tags: get(pres, "medicineDetails.tags"),
		}
	})
	return {
		prescriptionMedicationList: medicinePrescriptionList,
		referenceId: medicinePrescription.referenceId,
		patientId,
	}
}

export const createNewMedicinePrescription = (medicinePrescription: IPrescriptionMedicine, userId: number, referenceId: string): IPrescriptionMedication => {
	const medicinePrescriptionList = map(medicinePrescription?.prescriptionMedicationList, (pres) => {
		return {
			userId,
			referenceId: referenceId,
			code: pres.code,
			dosage: pres.medicineDosage,
			frequency: pres.frequency,
			instructions: get(pres, "medicineInstructions"),
			metadata: {
				comments: pres.comments,
				slotList: pres.slotList,
				quantity: pres.medicineQuantity,
				duration: pres.medicineDuration,
			},
			prescribedOn: Date.now(),
		}
	})
	return {
		prescriptionMedicationList: medicinePrescriptionList,
		referenceId: referenceId,
		userId,
		prescribedOn: Date.now(),
	}
}

export const getMediaDevices = () => {
	return new Promise((resolve, reject) => {
		if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
			console.log("enumerateDevices() not supported.")
			reject("enumerateDevices() not supported.")
		}

		// List cameras and microphones.
		navigator.mediaDevices
			.enumerateDevices()
			.then(function (devices) {
				const availableDevices: any[] = []
				uniqBy(devices, "deviceId").forEach(function (device: any) {
					const { label, kind } = device
					availableDevices.push({ label, kind })
				})

				resolve(JSON.stringify(uniqBy(availableDevices, "kind")))
			})
			.catch(function (err) {
				console.log(err.name + ": " + err.message)
				reject(`${err.name}: ${err.message}`)
			})
	})
}

export const formatPDFPages = (data: any, containerNode: any, maxHeight: number, defaultComponentGapSize: number) => {
	// Assumption - no sub-section child will be greater then max-height
	const dataObj: { [index: string]: any } = { ...data }
	const updatedList: any[] = []
	let heightOffset = 0,
		currHeight = 0
	let updatedObj: any = {}

	const formatChildNode = (parentId: string, index: number, childNodeHeight: number) => {
		currHeight += childNodeHeight
		if (currHeight <= maxHeight) {
			heightOffset = currHeight
			const subSecNode = updatedObj[parentId] ? [...updatedObj[parentId]] : []
			updatedObj[parentId] = [...subSecNode, dataObj[parentId][index]]
			return
		} else {
			updatedList.push(updatedObj)
			updatedObj = {}
			;(currHeight = defaultComponentGapSize), (heightOffset = defaultComponentGapSize)
			formatChildNode(parentId, index, childNodeHeight)
		}
	}

	const formatNodes = (element: any) => {
		currHeight += element.clientHeight
		if (currHeight <= maxHeight) {
			heightOffset = currHeight
			if (dataObj[element.id]) {
				updatedObj[element.id] = dataObj[element.id]
			}
		} else if (!dataObj[element.id]?.length) {
			updatedList.push(updatedObj)
			updatedObj = {}
			;(currHeight = defaultComponentGapSize), (heightOffset = defaultComponentGapSize)
			formatNodes(element)
		} else {
			const id = element.id
			const subSecId = id + "-subsection"
			const subsectionNode = document.getElementById(subSecId)
			if (subsectionNode && subsectionNode.children && subsectionNode.children.length > 0) {
				currHeight = heightOffset + defaultComponentGapSize
				map(subsectionNode.children, (nodeItem: any, index: number) => {
					formatChildNode(element.id, index, nodeItem.clientHeight)
				})
			}
		}
	}

	if (containerNode.children && containerNode.children.length > 0) {
		map(containerNode.children, (element: any) => {
			formatNodes(element)
		})
	}
	updatedList.push(updatedObj)
	return updatedList
}

export const formatStrongTag = (htmlString: string) => {
	return (htmlString || "").replace(/<strong/g, "<strong style='font-weight: bold'");
}

export const medicineSlotListEmpty = (slotList: ISlotList[]) => {
	return isEmpty(slotList) || slotList.every((currSlot: ISlotList) => !currSlot?.quantity)
}

export const createMedicineSlotList = (medicineDosage: string, medicineQty = 1) => {
	const slotList: ISlotList[] = []
	const slotArray = (medicineDosage || "").split("-")
	const quantity = medicineQty
	if (!isEmpty(slotArray) && slotArray.length > 1) {
		slotArray.forEach((s: string, i: number) =>
			slotList.push({
				slot: ["BREAKFAST", "LUNCH", "DINNER"][i],
				quantity: Number(s) * Number(quantity),
			})
		)
	}

	return slotList
}

export const getMedicineDosageTextArray = (slotList: ISlotList[], medicineUnit: string): string[] => {
	let morningMedQty, afternoonMedQty, nightMedQty
	if (!isEmpty(slotList)) {
		forEach(slotList, (slot) => {
			switch (slot.slot) {
				case MedicineSlot.BREAKFAST: {
					morningMedQty = slot.quantity
					break
				}
				case MedicineSlot.LUNCH: {
					afternoonMedQty = slot.quantity
					break
				}
				case MedicineSlot.DINNER: {
					nightMedQty = slot.quantity
					break
				}
			}
		})
	}

	const dosageTextArr: string[] = []
	;[morningMedQty, afternoonMedQty, nightMedQty].forEach((qty, index) => {
		if (Number(qty) > 0) dosageTextArr.push(`${qty} ${medicineUnit || ""} - ${["Morning", "Afternoon", "Night"][index]}`)
	})

	return dosageTextArr
}

export const setPrecisionIfDecimal = (value: number): number => {
	if (!isNumber(value)) return value
	if (Math.floor(value) === value) return value
	else return value && Number(value.toFixed(2))
}

export const getGoalTargetByTargetType = (patientGoal: IPatientGoal | Partial<IPatientGoal>): string => {
	if (patientGoal.target.low != null && patientGoal.target.high != null) {
		return `${setPrecisionIfDecimal(patientGoal.target.low)} - ${setPrecisionIfDecimal(patientGoal.target.high)}`
	} else if (patientGoal.target.low != null) {
		return `${setPrecisionIfDecimal(patientGoal.target.low)}`
	} else if (patientGoal.target.high != null) {
		return `${setPrecisionIfDecimal(patientGoal.target.high)}`
	}
	return ""
}

export const getMeasureFrequencyType = (measureData: { type: string; value: number }): GoalMeasureFrequencyType => {
	const type: string = measureData.type
	const value: number = measureData.value
	if (type === "DAY_GAP" && value === 1) return GoalMeasureFrequencyType.EVERY_DAY
	else if (type === "DAY_GAP" && value === 2) return GoalMeasureFrequencyType.EVERY_ALTERNATE_DAY
	else if (type === "WEEK_GAP" && value === 1) return GoalMeasureFrequencyType.EVERY_WEEK
	else if (type === "WEEK_GAP" && value === 2) return GoalMeasureFrequencyType.EVERY_FORTNIGHT
	else if (type === "MONTH_GAP" && value === 1) return GoalMeasureFrequencyType.EVERY_MONTH
	else return GoalMeasureFrequencyType.EVERY_3_MONTH
}

export const getPlanAdherenceCategory = (percent: number) => {
	if (percent <= 0.5) return "Low"
	if (percent > 0.5 && percent <= 0.75) return "Medium"
	if (percent > 0.75) return "High"
	return "-"
}

export const getSpecialityNameFromCode = (specialityCode: string): string => {
	let name = specialityCode
	forEach(referralStaticData, (value, key) => {
		if (specialityCode === value.internalValue) {
			name = value.displayValue
			return false
		}
	})
	return name
}

export const setPdfTemplatesIdToNameMap = (constituentTemplates: IConstituentTemplate[]) => {
	const idToNameMap: { [key: string]: string } = {}
	if (!isEmpty(constituentTemplates)) {
		constituentTemplates.forEach((template: IConstituentTemplate) => {
			idToNameMap[template.id] = template.name
		})
	}
	return idToNameMap
}

export const setPdfTemplateNameToDataMap = (constituentTemplates: IConstituentTemplate[]) => {
	const nameToDataMap: { [key: string]: string } = {}
	if (!isEmpty(constituentTemplates)) {
		constituentTemplates.forEach((template: IConstituentTemplate) => {
			nameToDataMap[template.name] = template.data
		})
	}
	return nameToDataMap
}

export const getStaticPdfConstituent = (): IConstituentTemplate[] => {
	return [
		{
			data: goalsTemplate,
			name: "patientGoals",
			id: 1112,
			constituentTemplates: null,
		},
		{
			data: adherenceTemplate,
			name: "patientAdherence",
			id: 1113,
			constituentTemplates: null,
		},
		{
			data: patientDoctorInfoTemplate,
			name: "patientAndDoctorInfo",
			id: 1114,
			constituentTemplates: null,
		},
		{
			data: patientVitalTableTemplate,
			name: "patientVitals",
			id: 1115,
			constituentTemplates: null,
		},
		{
			data: patientHealthOverviewTemplate,
			name: "healthOverview",
			id: 1116,
			constituentTemplates: null,
		},
		{
			data: goalsRecommendationTemplate,
			name: "goalRecommendation",
			id: 1117,
			constituentTemplates: null,
		},
		{
			data: faceBasedVitalsTemplate,
			name: "faceBasedVitals",
			id: 1118,
			constituentTemplates: null,
		},
		{
			data: conditionAssessmentTemplate,
			name: "conditionAssessment",
			id: 1119,
			constituentTemplates: null,
		},
		{
			data: prescriptionActiveFoodsTemplate,
			name: "prescriptionActiveFoodsRecommendations",
			id: 1122,
			constituentTemplates: null,
		},
		{
			data: doctorSignatureTemplate,
			name: "doctorSignature",
			id: 1120,
			constituentTemplates: null,
		},
		{
			data: bundlePackBanner,
			name: "bundlePack",
			id: 1121,
			constituentTemplates: null,
		},
		{
			// GLP-1 contraindication-screening summary; rendered in the prescription PDF below
			// public notes when the FM filled out the section on a first-time GLP-1 prescription.
			data: currentVisitSummaryTemplate,
			name: "currentVisitSummary",
			id: 1123,
			constituentTemplates: null,
		},
	]
}

export const getPatientAge = (patientDetails: IPatientDetail): number => {
	return !isNil(patientDetails.age) ? patientDetails.age : getAgeFromRecordedAge(patientDetails.recordedAge, new Date(patientDetails.recordedBirthDate))
}

export const removeBracketsFromSelectedString = (selectedString: string) => {
	if (selectedString.indexOf("<<<") > -1 && selectedString.indexOf(">>>") > -1) {
		selectedString = selectedString.replace(new RegExp("<<<", "g"), "").replace(new RegExp(">>>", "g"), "")
	}
	return selectedString
}

export const isWordAlreadyLinked = (word: string, contentNameMap: Record<string, IContentNameMapRHS>, selectionRange: ISelectionStringRange, matchCb?: (link: string) => void) => {
	const result = Object.keys(contentNameMap).some((existingWord) => {
		if (existingWord === word && selectionRange.start === contentNameMap[existingWord].selectionRange.start && selectionRange.end === contentNameMap[existingWord].selectionRange.end) {
			matchCb?.(contentNameMap[existingWord].link)
			return true
		}
	})

	return result
}

export const generateTextBlogUrl = (id: string) => {
	return TEXT_BLOG_DEEPLINK_TEMPLATE.replace("id", id)
}

export const generateVideoBlogOrInfoBiteUrl = (videoDetails: { videoUrl: string; title: string; thumbnailUrl: string }) => {
	return VIDEO_BLOG_OR_INFO_BITE_DEEPLINK_TEMPLATE.replace("$videoUrl", videoDetails.videoUrl)
		.replace("$title", encodeURIComponent(videoDetails.title))
		.replace("$thumbnailUrl", videoDetails.thumbnailUrl)
}

export const getAxiosErrorMsg = (e: AxiosError<any>) => {
	return e?.response?.data?.debugMessage || e?.message || ""
}

export const getMonthsToYearsString = (totalMonths: number) => {
	if (!totalMonths) return ""
	if (totalMonths < 12) {
		return `${totalMonths} months`
	}
	return `${Math.floor(totalMonths / 12)} ${Math.floor(totalMonths / 12) > 1 ? "years" : "year"} ${totalMonths % 12 > 0 ? `, ${totalMonths % 12} months` : ""}`
}
export const getComposedPublicNoteForFirstConsult = (data: IFetchUserAutomatedPublicNotesResponse): string => {
	if (isEmpty(data)) return ""
	const {
		name,
		diabetesConditionName,
		diabetesAgeInMonths,
		hba1c,
		alt,
		ast,
		hdl,
		ldl,
		uricAcid,
		fbs,
		lifestyle,
		medicines,
		drugAllergies,
		complications,
		familyHistory,
		bmi,
		bmiSummary,
		surgeries,
	} = data
	const composedSentences: string[] = []
	if (name) composedSentences.push(`${capitaliseText(name)}`)
	if (diabetesConditionName) composedSentences.push(`has ${diabetesConditionName}`)
	if (diabetesAgeInMonths) composedSentences.push(`for ${getMonthsToYearsString(diabetesAgeInMonths)}`)
	if (!!name && !!diabetesConditionName) {
		composedSentences.push(`${capitaliseText(name)} has ${diabetesConditionName} for ${getMonthsToYearsString(diabetesAgeInMonths)}`)
	}
	if (!isEmpty(complications)) {
		const joinedComplications = `\nRemaining past complications: ${complications.join(", ")}.`
		composedSentences.push(joinedComplications)
	}
	const noDiagnostics = !hba1c && !fbs && !ldl && !hdl && !alt && !ast && !uricAcid
	let userDiagnosticStats = noDiagnostics ? "" : "\nThe current "
	if (hba1c) userDiagnosticStats = userDiagnosticStats.concat(`Hba1c is ${hba1c}%${!fbs ? "." : ""}`)
	if (fbs) userDiagnosticStats = userDiagnosticStats.concat(`, Fasting Blood Sugar is ${fbs} mg/dl${!ldl ? "." : ""}`)
	if (ldl) userDiagnosticStats = userDiagnosticStats.concat(`, LDL is ${ldl} mg/dl${!hdl ? "." : ""}`)
	if (hdl) userDiagnosticStats = userDiagnosticStats.concat(`, HDL is ${hdl} mg/dl${!alt ? "." : ""}`)
	if (alt) userDiagnosticStats = userDiagnosticStats.concat(`, ALT/SGPT is ${alt} U/L${!ast ? "." : ""}`)
	if (ast) userDiagnosticStats = userDiagnosticStats.concat(`, AST/SGOT is ${ast} U/L${!uricAcid ? "." : ""}`)
	if (uricAcid) userDiagnosticStats = userDiagnosticStats.concat(`, Uric Acid is ${uricAcid} mg/dl.`)
	composedSentences.push(userDiagnosticStats)
	if (!!bmi && !!bmiSummary) composedSentences.push(`\nBMI is ${bmi}, which is ${bmiSummary}.`)
	if (!isEmpty(medicines)) {
		const joinedMedicines = `\nUser is taking: ${medicines.join(", ")}`
		composedSentences.push(joinedMedicines)
	}
	if (!isEmpty(drugAllergies)) {
		const joinedAllergies = `\nAllergies: ${drugAllergies.join(", ")}`
		composedSentences.push(joinedAllergies)
	}
	if (!!lifestyle && !!USER_LIFESTYLE_MAP[lifestyle]) composedSentences.push(`\n${USER_LIFESTYLE_MAP[lifestyle]} lifestyle.`)
	if (!isEmpty(surgeries)) {
		const joinedSurgeries = `\nPast Surgeries: ${surgeries.join(", ")}.`
		composedSentences.push(joinedSurgeries)
	}
	if (!isEmpty(familyHistory)) {
		const joinedFamilyHistory = `\nFamily history: ${familyHistory.join(", ")}.`
		composedSentences.push(joinedFamilyHistory)
	}

	return composedSentences.join("")
}

export const positiveNumberValidation = (inputText: string): string => {
	if (inputText == "") return null
	if (/^([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(inputText)) {
		return inputText
	}
	return inputText.substr(0, inputText.length - 1)
}

export const getEndOFDayEpoch = (epoch: number) => {
	const currDate = new Date(epoch)
	currDate.setHours(23, 59, 59, 999)
	return currDate.getTime()
}

export const getStartOFDayEpoch = (epoch: number) => {
	const currDate = new Date(epoch)
	currDate.setHours(0, 0, 0, 0)
	return currDate.getTime()
}

export const getTimeInDecimalMinutesFromSeconds = (timeInSeconds: number) => {
	let timeToReturn = null
	if (timeInSeconds !== undefined && timeInSeconds !== null && timeInSeconds.toString() !== "") {
		timeToReturn = `${parseInt(timeInSeconds / 60 + "")}.${timeInSeconds % 60}`
	}
	return timeToReturn
}

export const getTimeInDecimalHoursFromSeconds = (timeInSeconds: number) => {
	let timeToReturn = null
	if (timeInSeconds !== undefined && timeInSeconds !== null && timeInSeconds.toString() !== "") {
		timeToReturn = `${parseInt(timeInSeconds / 3600 + "")}.${(timeInSeconds % 3600) / 60}`
	}
	return timeToReturn
}

export const generateInterventionPayload = (interventions: IIntervention[], patientId: number | string, doctorId: number, tenant: AppTenants, forDraft = false) => {
	let isPlanChanged = false
	const updatedIntervention = [...(interventions || [])]
	updatedIntervention.forEach((intervention: IIntervention) => {
		// @ts-ignore
		delete intervention.skill["text"]
		if (intervention.skill.pillar) {
			delete intervention.skill.pillar["skillActions"]
		}

		if (intervention.isUpdatedOrNew) {
			isPlanChanged = isPlanChanged || intervention.isUpdatedOrNew
			!forDraft && delete intervention["isUpdatedOrNew"]
		}
	})
	return isPlanChanged
		? {
				userId: patientId,
				tenant: tenant || AppTenants.SUGARFIT,
				motivatorId: doctorId,
				userActions: updatedIntervention,
				challenges: [] as any,
				peers: [] as any,
				notes: {},
		  }
		: {}
}

export const generateGoalsPayload = (patientGoals: IPatientGoal[]) => {
	const updatedPatientGoals: IPatientGoal[] = []
	patientGoals &&
		patientGoals.forEach((patientGoal: IPatientGoal) => {
			if (!patientGoal.saveToDB) return
			const updatedPatientGoal = { ...patientGoal }
			updatedPatientGoal.goal = {
				id: patientGoal.goal.id,
			}
			delete updatedPatientGoal.saveToDB
			delete updatedPatientGoal.status
			updatedPatientGoals.push(updatedPatientGoal)
		})
	return updatedPatientGoals
}

export const getHourMinuteFormattedDate = (epochTime: number | string) => {
	return moment(epochTime).format("HH:mm")
}

export const createTableConfigFromOpsBookingResponse = (res: any, cgmRequestStatus: ICgmRequestStatus) => {
	const data: any[] = []
	const columns: ColumnsType = [
		{
			key: "bookingType",
			title: "Booking Type",
			dataIndex: "bookingType",
		},
		{
			key: "status",
			title: "Status",
			dataIndex: "status",
		},
	]

	if (!isEmpty(res)) {
		Object.keys(res).forEach((key: string) => {
			switch (key) {
				case "cgmTaskType":
					data.push({
						key: key,
						bookingType: OPS_BOOKING_CONSTANTS[res[key]],
						status: res.cgmTaskScheduledDate ? getOneHourSlotFromStartEpoch(res.cgmTaskScheduledDate) : getPendingStatusString(res.cgmTaskStatus),
					})
					break
				case "wkDeliveryStatus":
					data.push({
						key: key,
						bookingType: "Welcome Kit",
						status: res.wkDeliveryScheduledDate ? getOneHourSlotFromStartEpoch(res.wkDeliveryScheduledDate) : getPendingStatusString(res.wkDeliveryStatus),
					})
					break
				case "diagnosticStatus":
					data.push({
						key: key,
						bookingType: "Diagnostic Sample Collection",
						status: res.diagnosticSampleCollectionScheduledDate ? getOneHourSlotFromStartEpoch(res.diagnosticSampleCollectionScheduledDate) : getPendingStatusString(res.diagnosticStatus),
					})
					break
				case "additionalCGMRequestedDate":
					if (res.additionalCGMRequestedDate) {
						data.push({
							key: key,
							bookingType: "Additional Requested CGM",
							status: moment(res.additionalCGMRequestedDate).format("DD MMM YYYY, hh:mm A"),
						})
					}
					break
				default:
					break
			}
		})
	}

	if (cgmRequestStatus?.requestedDate) {
		data.push({
			key: "cgm-request-status",
			bookingType: "Cgm Installation Request",
			status: `Requested on ${moment(cgmRequestStatus.requestedDate).format("DD MMM 'YY")}`,
		})
	}

	return {
		columns: columns,
		data: data.filter((row) => !!row.status),
	}
}

const getPendingStatusString = (status: string) => {
	return status === "PENDING" ? "Pending on Ops" : status
}

export const copyTextToClipboard = (text: string): Promise<any> => {
	return new Promise((resolve, reject) => {
		const textArea = document.createElement("textarea")
		textArea.value = text
		textArea.style.position = "fixed"
		document.body.appendChild(textArea)
		textArea.focus()
		textArea.select()
		try {
			const success = document.execCommand("copy")
			if (success) {
				document.body.removeChild(textArea)
				resolve({
					isSuccess: success,
					data: text,
				})
			} else {
				document.body.removeChild(textArea)
				reject({
					isSuccess: success,
					data: null,
				})
			}
		} catch (err) {
			document.body.removeChild(textArea)
			reject({
				isSuccess: false,
				data: err,
			})
		}
	})
}

export const searchOnGoogle = (searchQuery: string) => {
	window.open(`http://google.com/search?q=${searchQuery}`)
}

export const createNewDishSaveInfo = (dishName: string, nutritionInfo: IDishNutritionInfo, primaryUnit: string, conversionToGrams: number, doctorId: string) => {
	return {
		dataSource: "COACH",
		description: dishName,
		name: dishName,
		nutritionInfo: {
			calories: nutritionInfo.calories,
			carbohydrates: nutritionInfo.carbohydrates,
			fat: nutritionInfo.fat,
			fibre: nutritionInfo.fibre,
			protein: nutritionInfo.protein,
		},
		source: "COACH",
		primaryUnit: primaryUnit,
		tags: [
			{
				key: "agentId",
				value: doctorId,
			},
		],
		units: [
			{
				conversionToGrams: conversionToGrams,
				unit: primaryUnit,
			},
		],
	}
}

export const getIsUltrafit = () => {
	const cookies = new Cookies()
	const memberships = get(cookies.get("userContext"), "memberships", [])
	const isUltrafitUser = memberships.findIndex((membership: { context: string; roleName: RoleNames }) => membership.roleName === RoleNames.ULTRAFIT) !== -1
	return isUltrafitUser
}

export const createUnreadInfoMap = (data: IChatConversationSummary[], doctorId: number): Record<number, IChatConversationSummary> => {
	const generatedMap: Record<number, IChatConversationSummary> = {}
	if (!isEmpty(data) && doctorId) {
		data.forEach((conversation) => {
			if (conversation?.communityEntry?.communityType !== COACH_COMMUNITY_TYPE_ENUM.COACH_USER_GROUP && conversation?.usersInfo?.[0]?.userId)
				generatedMap[conversation.usersInfo[0].userId] = { ...conversation, doctorId: doctorId }
		})
	}
	return generatedMap
}

export const getIsOnlyCommunityManagerUsingCookies = () => {
	const cookies = new Cookies()
	const memberships: WatchmenMembership[] = get(cookies.get("userContext"), "memberships", [])
	const communityMembership = memberships.find((role: any) => role.roleName === RoleNames.COMMUNITY_MANAGER)
	return memberships.length === 1 && !isEmpty(communityMembership)
}

export const getIsCommunityManagerUsingCookies = () => {
	const cookies = new Cookies()
	const memberships: WatchmenMembership[] = get(cookies.get("userContext"), "memberships", [])
	const communityMembership = memberships.find((role: any) => role.roleName === RoleNames.COMMUNITY_MANAGER)
	return !isEmpty(communityMembership)
}

export const hasBlockUserRole = () => {
	const cookies = new Cookies()
	const memberships: WatchmenMembership[] = get(cookies.get("userContext"), "memberships", [])
	const blockUserRole = memberships.find((role: any) => role.roleName === RoleNames.BLOCK_USER)
	return !isEmpty(blockUserRole)
}

export const getConsultationType = () => {
	const isEditConsult = window.location.pathname.includes("edit-coach-consult")
	const isOngoingConsult = window.location.pathname.includes("coach-consult")
	const isDoctorConsult = window.location.pathname.includes("doctor-consult")
	if (isEditConsult) return ConsultationType.COACH_EDIT
	if (isOngoingConsult) return ConsultationType.COACH_ONGOING
	if (isDoctorConsult) return ConsultationType.DOCTOR_ONGOING
	return ""
}

export const getStaticCuisines = (): SelectProps["options"] => {
	return map(reduxStore?.getState()?.staticData?.cuisines, (cuisine) => ({ label: capitaliseText(cuisine.displayValue), value: cuisine.internalValue }))
}

export const stringCompareByLength = (s1: string, s2: string) => {
	return s1.length - s2.length
}

export const stringCompare = (s1: string, s2: string) => {
	if (s1 > s2) return -1
	else if (s1 < s2) return 1
	return 0
}

export const transformDietTemplateToPlan = (dietTemplate: IDietTemplate, doctorId?: number, patientId?: number, referenceId?: number): IUserMealPlan => {
	return {
		_id: dietTemplate?._id,
		createdAt: dietTemplate?.createdAt,
		dailyUserCalorieRequirement: dietTemplate?.templateCalories,
		dailyUserMacroRequirements: dietTemplate?.templateMacroRequirements,
		dietPlanTemplateId: null,
		doctorId: doctorId,
		id: dietTemplate?.id,
		isPlanChanged: false,
		lastModifiedOn: dietTemplate?.lastModifiedOn,
		meals: map(dietTemplate?.dietThemes, (theme) => {
			const updatedTheme = { ...(theme || {}), mealSlot: theme.slot } as IDietTheme
			forEach(updatedTheme?.details?.calorieBreakup, (breakup, index) => {
				set(updatedTheme, `details.calorieBreakup.${index}`, [breakup])
			})
			delete updatedTheme["slot"]
			return updatedTheme
		}),
		name: dietTemplate?.name,
		patientId: patientId,
		referenceId: dietTemplate?.referenceId ? Number(dietTemplate?.referenceId) : referenceId,
		source: dietTemplate?.source || VitalsEditSourceName,
		updatedAt: dietTemplate?.lastModifiedOn,
		tags: dietTemplate?.tags,
		foodTypes: dietTemplate?.foodTypes,
		cuisines: dietTemplate?.cuisines,
	}
}

export const transformDietPlanToTemplate = (userMealPlan: IUserMealPlan, doctorId?: number, saveStatus?: DIET_PLAN_SAVE_STATUS): IDietTemplate => {
	return {
		_id: userMealPlan?._id,
		createdAt: userMealPlan?.createdAt,
		templateCalories: userMealPlan?.dailyUserCalorieRequirement,
		templateMacroRequirements: userMealPlan?.dailyUserMacroRequirements,
		dietPlanTemplateId: null,
		doctorId: doctorId,
		id: userMealPlan?.id,
		isPlanChanged: false,
		lastModifiedOn: userMealPlan?.lastModifiedOn,
		dietThemes: map(userMealPlan?.meals, (theme) => {
			const updatedTheme = { ...(theme || {}), slot: theme.mealSlot } as IDietTheme
			forEach(updatedTheme?.details?.calorieBreakup, (breakup, index) => {
				set(updatedTheme, `details.calorieBreakup.${index}`, breakup?.[0])
			})
			delete updatedTheme["mealSlot"]
			return updatedTheme
		}),
		name: userMealPlan?.name,
		referenceId: userMealPlan?.referenceId ? String(userMealPlan?.referenceId) : null,
		source: userMealPlan?.source || VitalsEditSourceName,
		updatedAt: userMealPlan?.lastModifiedOn,
		tags: userMealPlan?.tags,
		foodTypes: userMealPlan?.foodTypes,
		cuisines: userMealPlan?.cuisines,
		status: saveStatus,
	} as IDietTemplate
}

export const hasAccess = (checkRoles: RoleNames[] = []) => {
	const accountData = reduxStore?.getState()?.accountData
	const memberships = get(accountData, "memberships", []) as WatchmenMembership[]
	for (const roleName of checkRoles) {
		const communityMembership = memberships.find((role: any) => role.roleName === roleName)
		if (!isEmpty(communityMembership)) return true
	}
	return false
}

export const getFileType = (mimeType: string): FileType => {
	if (includes(mimeType, "audio")) return FileType.AUDIO
	if (includes(mimeType, "video")) return FileType.VIDEO
	if (includes(mimeType, "image")) return FileType.IMAGE
}

export const stopPropagation = (event: any, cb: () => void) => {
	event.stopPropagation()
	cb()
}

export const getTimezoneTime = (inputTime: number, timezone: string) => {
	if (inputTime && timezone) {
		const now = moment()
		const localOffset = now.utcOffset()
		now.tz(timezone)
		const targetOffset = now.utcOffset()
		const diffInMilliseconds = (localOffset - targetOffset) * 60 * 1000
		console.log("timezone diff millisecond", diffInMilliseconds)
		return inputTime - diffInMilliseconds
	}
	return inputTime
}

export const getOdinTargetUrl = () => {
	if (window.location.hostname.includes("synapse.stage.curefit.co")) {
		return "https://odin.stage.curefit.co"
	}
	if (window.location.hostname.includes("synapse.alpha.curefit.co")) {
		return "https://odin.alpha.curefit.co"
	}
	return "https://odin.curefit.co"
}

export const getOdinFieldConfig = () => {
	if (window.location.hostname.includes("synapse.stage.curefit.co")) {
		return {
			FIELDS_CONFIG: { UHID: 462, CATEGORY: 370, SUB_CATEGORY: 371, TITLE: 339, DESCRIPTION: 340, PRIORITY: 341, DUE_DATE: 372, ASSIGNEE: 342 },
			ODIN_SOURCE: "EMR",
			// ODIN_SOURCE_REF_ID: 1,
		}
	}

	if (window.location.hostname.includes("synapse.alpha.curefit.co")) {
		return {
			FIELDS_CONFIG: { UHID: 349 },
			ODIN_SOURCE: "EMR",
			// ODIN_SOURCE_REF_ID: 1,
		}
	}

	return {
		FIELDS_CONFIG: { UHID: 349 },
		ODIN_SOURCE: "EMR",
		// ODIN_SOURCE_REF_ID: 1,
	}
}

export const getAvailableAppLanguagesAsSelectOptions = () => {
	const options: SelectProps["options"] = []
	Object.keys(AvailableAppLanguages).forEach((language) => {
		options.push({
			label: language,
			//@ts-ignore
			value: AvailableAppLanguages[language],
		})
	})
	return options
}

const recursiveIsEmpty = (value: any): any => {
		if (isNil(value) || isEmpty(value)) return true;
		if (isObject(value)) {
		  return every(value, recursiveIsEmpty);
		}
		return false;
};

export const isObjectEmptyAtEveryLevel = (obj: any) => {
	return recursiveIsEmpty(obj);
}

export const isAgentOfPsychologistSubService = (doctorProfile: IDoctorProfile) => {
	if(isEmpty(doctorProfile)) return false
	return doctorProfile?.primarySubServiceType?.code === PSYCHOLOGIST_SUB_SERVICE_TYPE
}


export const isAgentPsychologist = () => {
	const accountData = reduxStore?.getState()?.accountData
	const hasPsychologistMembership = accountData?.memberships?.some((membership: any) => membership?.roleName === RoleNames.PSYCHOLOGIST)
	return hasPsychologistMembership && isAgentOfPsychologistSubService(reduxStore?.getState()?.doctorProfile)
}


/**
 * Wraps an async function with retry logic.
 *
 * @template Args - argument types for the wrapped function
 * @template R - return type of the wrapped function
 * @param fn - The async function to wrap (e.g., a mutateAsync call)
 * @param retryCount - Number of times to retry on failure
 * @param retryDelay - Delay in milliseconds between retries
 * @returns A new function that, when called, invokes `fn` and retries on rejection.
 */
export function retryWrapper<Args extends any[], R>(
  fn: (...args: Args) => Promise<R>,
  retryCount: number,
  retryDelay: number
): (...args: Args) => Promise<R> {
  return async (...args: Args): Promise<R> => {
    let attempt = 0;
    while (true) {
      try {
        return await fn(...args);
      } catch (error) {
		console.log(`Attempt ${attempt + 1} failed:`, error);
		
        if (attempt >= retryCount) {
          throw error;
        }
        attempt++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  };
}
